module.exports = __webpack_public_path__ + "img/kefu.V=0.1.0_202601151459.png";